export default __webpack_public_path__ + "static/media/abid4.bfe6365c.jpg";